// Currency symbols mapping
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  PHP: '₱',
  AUD: 'A$',
  CAD: 'C$',
  CNY: '¥',
  INR: '₹',
};

export function formatCurrency(amount: number, currency: string = 'USD', decimals: number = 2): string {
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  const num = typeof amount === 'number' && !isNaN(amount) && isFinite(amount) ? amount : 0;
  return `${symbol}${num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
}

export function getCurrencySymbol(currency: string = 'USD'): string {
  return CURRENCY_SYMBOLS[currency] || currency;
}

export function formatNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '0';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '0';
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
}
